import styled from "styled-components";
import { Company } from "../../../../../common/cards/product-card/views/desktop/styled.js";
export const ProductCardTransport = styled.div.withConfig({
    displayName: "styled__ProductCardTransport",
    componentId: "sc-ee5f79b1-0"
})`
	${Company} {
		border: none;
		min-width: auto;
		padding-right: 4px;
		margin-right: auto;
		img {
			border: 1px solid ${({ theme  })=>theme.colors.grays.light};
			border-radius: 50%;
		}
	}
`;

//# sourceMappingURL=styled.js.map